import React, { useState } from "react";
import { message, Alert } from "antd";
import CriticalActionModal from "./CriticalActionModal";
import { createRetroactiveWarning } from "../api/infractions/infractionRequest";

/**
 * Feature 3 — Generate a missing (retroactive) warning linked to an infraction.
 */
const RetroactiveWarningModal = ({ visible, onCancel, onSuccess, infraction }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async (reason) => {
    if (!infraction) return;
    setLoading(true);
    try {
      const response = await createRetroactiveWarning(infraction.id, reason);
      if (response?.success) {
        message.success(response.message || "Avertissement rétroactif créé avec succès");
        onSuccess?.(response.data);
      } else {
        message.error(response?.message || response?.error || "Erreur lors de la création");
      }
    } catch (error) {
      message.error(error.response?.data?.error || error.response?.data?.message || "Erreur lors de la création de l'avertissement");
    } finally {
      setLoading(false);
    }
  };

  return (
    <CriticalActionModal
      visible={visible}
      onCancel={onCancel}
      onConfirm={handleConfirm}
      loading={loading}
      title="Créer un avertissement rétroactif"
      okText="Créer l'avertissement"
      summaryItems={[
        { label: "Infraction", to: infraction?.reference || `#${infraction?.id ?? ""}` },
        { label: "Matricule", to: infraction?.matricule || "—" },
        { label: "Avertissement", from: "Aucun", to: "À créer" },
      ]}
      warningBanner={
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 8 }}
          message="Avertissement rétroactif"
          description="Un avertissement sera généré et lié à cette infraction."
        />
      }
    />
  );
};

export default RetroactiveWarningModal;
